import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AppLayout from './layout/Applayout';
import Home from './pages/Dashboard/Home';
import ViewAndEdit from './pages/Dashboard/timesheets/ViewAndEdit';

import AppActivity from './pages/Dashboard/Activity/AppActivity';
import UrlActivity from './pages/Dashboard/Activity/UrlActivity';
import Highlights from './pages/Dashboard/Insights/Highlights';
import Performance from './pages/Dashboard/Insights/Performance';
import UnusualActivity from './pages/Dashboard/Insights/UnusualActivity';
import SmartNotifications from './pages/Dashboard/Insights/SmartNotifications';

import AllProjects from './pages/Dashboard/Projects/AllProjects';
import ProjectDetails from './pages/Dashboard/Projects/ProjectDetails';


import AppsUrlsReport from './pages/report/app-url-report/AppsUrlsReport';
import DailyTotalsReport from './pages/report/app-url-report/DailyTotalsReport';




import TimeSheetAprovals from './pages/Dashboard/timesheets/TimeSheetAprovals';
import ScreenShots from './pages/ScreeenShorts/ScreenShots';
import ReportsPage from './pages/report/ReportsPage';
import ScheduledReportsTable from './pages/report/ScheduledReportsTable';
import TimeActivity from './pages/report/time-activity/TimeActivity';
import AmountsOwedReport from './pages/report/AmountsOwedReport/AmountsOwedReport';
import WorkSessionsReport from './pages/report/WorkSessionsReport/WorkSessionsReport';
import DailyTotals from './pages/report/DailyTotals/DailyTotals';
import ManualTimeEdits from './pages/report/manual-time-edits/ManualTimeEdits';
import ExpenseReports from './pages/blank-pages/ExpenseReports';
import TimesheetApprovalsReport from './pages/blank-pages/TimesheetApprovalsReport';
import WorkBreakReports from './pages/blank-pages/WorkBreakReports';
import AuditLog from './pages/report/audit-log/AuditLog';
import PaymentsReport from './pages/blank-pages/PaymentsReport';
import WeeklyLimitsReport from './pages/blank-pages/WeeklyLimitsReport';
import ClientBudgetsReport from './pages/blank-pages/ClientBudgetsReport';
import DailyLimitsReport from './pages/blank-pages/DailyLimitsReport';
import PeopleTeams from './pages/blank-pages/PeopleTeams';
import ProjectReports from './pages/blank-pages/ProjectReports';
import Members from './pages/People/Members';
import UserProfileEdit from './pages/Member-Profile-Edit/UserProfileEdit';
import FinancialsInvoices from './pages/blank-pages/FinancialsInvoices';
import FinancialsExpenses from './pages/blank-pages/FinancialsExpenses';
import SettingsPolicies from './pages/Settings/SettingsPoliciesPage/SettingsPolicies';
import EnableDisableFeatures from './pages/Settings/EnableDisable/EnableDisableFeatures';
import BillingSettings from './pages/billing-settings/BillingSettings';
import PricingPlans from './components/BillingSettings/PricingPlans';
import Settings from './pages/Settings/General-Settings/Settings';
import FeatureSettings from './pages/Settings/FeatureSettings/FeatureSettings';
import NotificationPage from './pages/Notification/NotificationPage';
import SubscriptionSettings from './components/BillingSettings/SubscriptionSettings';
import PaymentCardForm from './components/BillingSettings/PaymentCardForm';
import Organizations from './pages/organizations/Organizations';
import OrganizationSetup from './pages/OrganizationSetup';
import ScrollTop from './components/ScrollTop';
function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route index element={<Home />} />
          <Route path='/view-and-edit' element={<ViewAndEdit />} />
          <Route path='/apps' element={<AppActivity />} />
          <Route path='/urls' element={<UrlActivity />} />

          <Route path='/highlights' element={<Highlights />} />
          <Route path='/performance' element={<Performance />} />
          <Route path='/unusual-activity' element={<UnusualActivity />} />
          <Route path='/smart-notifications' element={<SmartNotifications />} />


          <Route path='/all-projects' element={<AllProjects />} />
          <Route path='/apps-urls-report' element={<AppsUrlsReport />} />
          <Route path='/project-details' element={<ProjectDetails />} />
          <Route path='/notification' element={<NotificationPage />}></Route>

          <Route path='/approvals' element={<TimeSheetAprovals />} />
          <Route path='/screenshorts' element={<ScreenShots />} />
          <Route path='/reports' element={<ReportsPage />} />
          <Route path='/scheduled-reports' element={<ScheduledReportsTable />} />
          <Route path='/time-and-activity' element={<TimeActivity />} />
          <Route path='/amounts-owed' element={<AmountsOwedReport />} />
          <Route path='/WorkSessionsReport' element={<WorkSessionsReport />} />
          {/* <Route path='/daily-totals' element={<DailyTotalsReport />} /> */}
          <Route path='/daily-totals' element={<DailyTotals />} />
          <Route path='/my-projects' element={<AllProjects />} />
          <Route path='/ManualTimeEdits' element={<ManualTimeEdits />} />
          <Route path='/ExpenseReports' element={<ExpenseReports />} />
          <Route path='/timesheet-approvals-report' element={<TimesheetApprovalsReport />} />
          <Route path='/WorkBreakReports' element={<WorkBreakReports />} />
          <Route path='/AuditLog' element={<AuditLog />} />

          <Route path='/PaymentsReport' element={<PaymentsReport />} />
          <Route path='/WeeklyLimitsReport' element={<WeeklyLimitsReport />} />
          <Route path='/DailyLimitsReport' element={<DailyLimitsReport />} />
          <Route path='/ProjectReports' element={<ProjectReports />} />
          <Route path='/clients' element={<ClientBudgetsReport />} />
          <Route path='/client-budgets-report' element={<ClientBudgetsReport />} />
          <Route path='/teams' element={<PeopleTeams />} />
          <Route path='/members' element={<Members />} />
          <Route path='/UserProfileEdit' element={<UserProfileEdit />} />
          <Route path='/invoices' element={<FinancialsInvoices />} />
          <Route path='/expenses' element={<FinancialsExpenses />} />
          <Route path='/all-settings' element={<SettingsPolicies />} />
          <Route path='/MySettingsPage' element={<EnableDisableFeatures />} />
          <Route path='/billing' element={<BillingSettings />} />
          <Route path='/PricingPlans' element={<PricingPlans />} />
          <Route path='/general' element={<Settings />} />
          <Route path='/feature' element={<FeatureSettings />} />
          <Route path='/subscription-settings' element={<SubscriptionSettings />} />
          <Route path='/PaymentCardForm' element={<PaymentCardForm />} />
          <Route path='/organizations' element={<Organizations />} />
          <Route path='/OrganizationSetup' element={<OrganizationSetup />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
